export default __webpack_public_path__ + "static/media/zealy-task.bee15cbb.svg";